import fetch from 'isomorphic-fetch';
import { checkHttpStatus, parseJSON } from '../utils';
import {
  GENERATE_SNAPSHOT_TIMELINE,
  ADD_SNAPSHOT_TIME,
  SET_SNAPSHOT_TIMELINE_INDEX,
  SET_INITIAL_TIMESTAMP,
  UPDATE_SNAPSHOT_TIMELINE_COUNT,
  SNAPSHOT_TIMESTAMP_REMOVED,
} from '../constants';
import { authLogoutAndRedirect } from './auth';
import ExploreAuth from '../utils/ExploreAuth';

const _limit = 15;

export function createSnapshot(imageUrl, slug, caption, watermark) {
  return (dispatch) => {
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          return dispatch(authLogoutAndRedirect());
        }
        return fetch(`${SERVER_URL}/live-cams/create_snapshot?watermark=${watermark}`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body: JSON.stringify({
            slug,
            caption,
            imageUrl,
          }),
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .catch((error) => {
            console.log(error);
          });
      });
  };
}

export function submitToContest(snapshotId, contestIds) {
  return (dispatch) => {
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          return dispatch(authLogoutAndRedirect());
        }
        return fetch(`${SERVER_URL}/snapshots/contests`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body: JSON.stringify({
            snapshot_id: snapshotId,
            contest_ids: contestIds,
          }),
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .catch((error) => {
            console.log(error);
          });
      });
  };
}

function timelineGenerated(timelineArray, index, snapshotMap) {
  return {
    type: GENERATE_SNAPSHOT_TIMELINE,
    payload: {
      timeline: timelineArray,
      timestampIndex: index,
      snapshotMap,
    },
  };
}

function expandTimelinePast(timelineArray, timestamp, limit) {
  if (!limit) {
    limit = _limit;
  }
  let timestampValue = timestamp;

  for (let i = limit; i > 0; i--) {
    timestampValue -= 1;
    timelineArray.unshift(timestampValue);
  }
  return timelineArray;
}

function expandTimelineFuture(timelineArray, timestamp, limit) {
  if (!limit) {
    limit = _limit;
  }
  let timestampValue = timestamp;

  for (let i = 0; i < limit; i++) {
    timestampValue += 1;
    timelineArray.push(timestampValue);
  }
  return timelineArray;
}

export function generateSnapshotTimeline(timestamp, limit, reset, snapshotMap, hlsStream) {
  return (dispatch, getState) => {
    const state = getState();
    if (!limit) {
      limit = _limit;
    }

    if (hlsStream) {
      const availableKeys = snapshotMap.keys;
      const closestTimestamp = availableKeys.reduce((prev, curr) => {
        return (Math.abs(curr - timestamp) < Math.abs(prev - timestamp)) ? curr : prev;
      });
      if (reset) {
        dispatch(setInitialTimestamp(closestTimestamp));
      }

      return dispatch(timelineGenerated(availableKeys, availableKeys.indexOf(closestTimestamp), snapshotMap));
    }

    if (reset) {
      dispatch(setInitialTimestamp(timestamp));
    }

    let timelineArray = [timestamp];

    timelineArray = expandTimelinePast(timelineArray, timestamp, limit);

    timelineArray = expandTimelineFuture(timelineArray, timestamp, limit);

    return dispatch(timelineGenerated(timelineArray, limit, snapshotMap));
  };
}

export function addSnapshotTime(timestamp, direction) {
  return {
    type: ADD_SNAPSHOT_TIME,
    payload: {
      direction,
      timestamp,
    },
  };
}

export function expandTimeline(index) {
  return (dispatch, getState) => {
    const state = getState();
    let timeline = state.takeSnapshot.timeline;
    const currentTimestamp = timeline[index];
    let timelineUpdated = false;

    if (index - 5 < 0) {
      timeline = expandTimelinePast(timeline, timeline[0]);
      timelineUpdated = true;
    } else if (index + 5 >= timeline.length) {
      timeline = expandTimelineFuture(timeline, timeline[timeline.length - 1]);
      timelineUpdated = true;
    }

    if (timelineUpdated) {
      const newIndex = timeline.findIndex((timestamp) => {
        return timestamp === currentTimestamp;
      });
      dispatch(timelineGenerated(timeline, newIndex));
    }
  };
}

export function removeTimestamp(index) {
  return (dispatch, getState) => {
    const state = getState();
    const timeline = state.takeSnapshot.timeline;
    let nextTimestamp =
      state.takeSnapshot.direction == 'forward'
        ? timeline[index + 1]
        : timeline[index - 1];
    const today = Date.now();
    const timestampNow = parseInt(
      today
        .toString()
        .split('')
        .slice(0, 10)
        .join(''),
      10,
    );
    if (nextTimestamp > timestampNow) {
      nextTimestamp = timeline[index - 1];
    }
    timeline.splice(index, 1);

    const newIndex = timeline.findIndex((timestamp) => {
      return timestamp === nextTimestamp;
    });
    dispatch(timelineGenerated(timeline, newIndex));
    dispatch(expandTimeline(newIndex));
    dispatch({ type: SNAPSHOT_TIMESTAMP_REMOVED });
  };
}

export function setCurrentSnapshotIndex(newIndex) {
  return (dispatch, getState) => {
    const state = getState();
    const direction =
      state.takeSnapshot.timestampIndex < newIndex ? 'forward' : 'back';

    dispatch({
      type: SET_SNAPSHOT_TIMELINE_INDEX,
      payload: {
        index: newIndex,
        direction,
      },
    });
    return dispatch(expandTimeline(newIndex));
  };
}

export function setInitialTimestamp(timestamp) {
  return {
    type: SET_INITIAL_TIMESTAMP,
    payload: {
      timestamp,
    },
  };
}

export function adjustCount(value) {
  return {
    type: UPDATE_SNAPSHOT_TIMELINE_COUNT,
    payload: {
      value,
    },
  };
}
